export function NewFeedSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/new-feed.svg'"></ng-include>`
    }
}